<template>
  <div />
</template>

<script>
  export default {
    created() {
      this.$store.dispatch('Auth/logout')
        .then(() => this.$router.push('/'))
    }
  }
</script>
